import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import config from '../config';

import { isElectron } from 'services/env-service';

import IconGoogle from '../icons/icon-google';

const GOOGLE_AUTH_URL = `${config.HOST}/auth/google`;

class GoogleLogin extends PureComponent {
    static defaultProps = {
        className: 'btn btn-secondary'
    };

    handleClick = event => {
        if (this.props.disabled) {
            event.preventDefault();
        }
    }

    render() {
        const { t } = this.props;

        const state = [];

        if (isElectron()) {
            state.push('isElectron=true');
        }

        if (this.props.acceptInviteToken) {
            state.push(`acceptInviteToken=${this.props.acceptInviteToken}`);
        }

        const sharedProps = {
            href: `${GOOGLE_AUTH_URL}?state=${state.join('|')}`,
            disabled: this.props.disabled
        };

        if (isElectron()) {
            sharedProps.target = '_blank';
        }

        if (this.props.children) {
            return <a {...sharedProps} style={{display: 'inline-block', verticalAlign: 'top'}}>{ this.props.children }</a>;
        }

        return (
            <a {...sharedProps} className={this.props.className + (this.props.disabled ? ' disabled' : '')}>
                <IconGoogle />

                { this.props.text ?? t('Sign in with Google') }
            </a>
        );
    }
}

export default withTranslation('apps')(GoogleLogin);
